// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uploadProgress_wrapper__28_y8","closeButton":"uploadProgress_closeButton__1mQhH"};